export default __webpack_public_path__ + "static/media/affiche2009.d0b4aaf8.png";